import type { Program } from "../profile/types";
import { TINTED_PANEL_CLASS } from "@/components/shared/tintedPanel";

export function ProgramsSection({ programs }: { programs: Program[] }) {
    if (programs.length === 0) return null;
    return (
        <section className="lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start lg:gap-x-16">
            <h2 className="text-section-title text-doberman-black text-balance">
                Programs
            </h2>
            <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:mt-0 lg:max-w-190">
                {programs.map((program) => (
                    <div key={program.name} className={TINTED_PANEL_CLASS}>
                        <p className="text-body font-semibold text-doberman-black">
                            {program.name}
                        </p>
                        <p className="mt-1 text-body-small text-doberman-black/60 leading-relaxed">
                            {program.description}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
}
